import { DSTile } from 'shared-definitions/types'
import { ApiTile } from 'data-source/types.wp'
import { pLinkMapper, PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'
import { imageMapper } from './imageMapper'

export function tileMapper(input: ApiTile, opts: PLinkMapperOpts): DSTile | null {
  const image = imageMapper(input.image, opts)
  if (!image) {
    return null
  }

  return {
    title: input.title,
    pLink: pLinkMapper(input.slug, opts),
    icon: input.icon,
    image,
  }
}
